import ShotShapeForm from './ShotShapeForm';

export default ShotShapeForm;
